import _toConsumableArray from "/var/lib/jenkins/workspace/minasidor.salabostader.se/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/lib/jenkins/workspace/minasidor.salabostader.se/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import { H } from "@jfrk/react-heading-levels";
import clsx from "clsx";
import React, { useState } from "react";
import { Icon } from "@whitespace/components";
import { useID } from "../hooks";
import * as defaultStyles from "./Accordion.module.css";
import withComponentDefaults from "../utils/withComponentDefaults";
import { filterAttributes } from "../utils";
export default withComponentDefaults(Accordion, "accordion");
var DefaultExpandIcon = function DefaultExpandIcon(props) {
  return /* @__PURE__ */React.createElement(Icon, __spreadValues({
    name: "chevron-down"
  }, props));
};
var DefaultCollapseIcon = function DefaultCollapseIcon(props) {
  return /* @__PURE__ */React.createElement(Icon, __spreadValues({
    name: "chevron-up"
  }, props));
};
function Accordion(_a) {
  var _b = _a,
    _b$components = _b.components;
  _b$components = _b$components === void 0 ? {
    ExpandIcon: DefaultExpandIcon,
    CollapseIcon: DefaultCollapseIcon
  } : _b$components;
  var _b$components$ExpandI = _b$components.ExpandIcon,
    ExpandIcon = _b$components$ExpandI === void 0 ? DefaultExpandIcon : _b$components$ExpandI,
    _b$components$Collaps = _b$components.CollapseIcon,
    CollapseIcon = _b$components$Collaps === void 0 ? DefaultCollapseIcon : _b$components$Collaps,
    items = _b.items,
    _b$styles = _b.styles,
    styles = _b$styles === void 0 ? defaultStyles : _b$styles,
    className = _b.className,
    showExpandAll = _b.showExpandAll,
    restProps = __objRest(_b, ["components", "items", "styles", "className", "showExpandAll"]);
  var attributes = filterAttributes(restProps);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    expandedRowIndexes = _useState2[0],
    setExpandedRowIndexes = _useState2[1];
  var id = useID();
  function rowIsExpanded(index) {
    return expandedRowIndexes.indexOf(index) !== -1;
  }
  var onExpandAllButtonClick = function onExpandAllButtonClick() {
    var atLeastOneRowIsExpanded = expandedRowIndexes.length;
    if (atLeastOneRowIsExpanded) {
      setExpandedRowIndexes([]);
    } else {
      var allRowIndexes = Array.from(Array(items.length).keys());
      setExpandedRowIndexes(allRowIndexes);
    }
  };
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    className: clsx(styles.component, className)
  }, attributes), showExpandAll && /* @__PURE__ */React.createElement("button", {
    onClick: onExpandAllButtonClick
  }, expandedRowIndexes.length ? /* @__PURE__ */React.createElement(React.Fragment, null, "ST\xC4NG") : /* @__PURE__ */React.createElement(React.Fragment, null, "\xD6PPNA")), /* @__PURE__ */React.createElement("ul", {
    className: clsx(styles.list),
    id: id("accordion")
  }, items.map(function (row, index) {
    return /* @__PURE__ */React.createElement("li", {
      className: clsx(styles.row),
      key: index
    }, /* @__PURE__ */React.createElement(H, {
      className: clsx(styles.title)
    }, /* @__PURE__ */React.createElement("button", {
      id: id("accordion-header-".concat(index)),
      "aria-expanded": rowIsExpanded(index),
      "aria-controls": id("accordion-panel-".concat(index)),
      className: clsx(styles.button),
      onClick: function onClick() {
        if (!rowIsExpanded(index)) {
          setExpandedRowIndexes([].concat(_toConsumableArray(expandedRowIndexes), [index]));
        } else {
          setExpandedRowIndexes(expandedRowIndexes.filter(function (currIndex) {
            return currIndex !== index;
          }));
        }
      }
    }, /* @__PURE__ */React.createElement("span", {
      className: clsx(styles.icon),
      "aria-hidden": "true"
    }, !rowIsExpanded(index) ? /* @__PURE__ */React.createElement(ExpandIcon, null) : /* @__PURE__ */React.createElement(CollapseIcon, null)), row.title)), /* @__PURE__ */React.createElement("section", {
      id: id("accordion-panel-".concat(index)),
      "aria-labelledby": id("accordion-header-".concat(index)),
      hidden: !rowIsExpanded(index),
      className: clsx(styles.content)
    }, row.content));
  })));
}